module.exports = "module.exports = __webpack_public_path__ + \"static/media/header.d8623501.template\";"